import {
  FacebookLeadgenBodyStyle,
  FacebookLeadgenButtonType,
  FacebookLeadgenFormType,
  FacebookLeadgenLocale,
  FacebookLeadgenQuestionType,
  FacebookLeadgenSharingOptions,
  LeadCardQuestion,
} from './LeadCard';
import { exampleAdImage } from './AdImage';

interface LeadCardCustomDisclaimerCheckBox {
  isRequired: boolean;
  isCheckedByDefault: boolean;
  text: string;
}

export interface LeadCardPrivacySettings {
  link: string;
  text?: string;
  customDisclaimer?: {
    title: string;
    body: string;
    checkboxes: LeadCardCustomDisclaimerCheckBox[];
  };
}

export interface LeadCardThankYou {
  headline: string;
  description: string;
  callToAction: FacebookLeadgenButtonType;
  buttonText: string;
  link: string;
  phoneNumber?: string;
  countryCode?: string;
}

export interface LeadCardIntro {
  imageID?: number;
  imageURL?: string;
  greeting?: {
    headline: string;
    bodyStyle: FacebookLeadgenBodyStyle;
    bodyItems: string[];
  };
}

export interface LeadCardCreateDTO {
  formName: string;
  formType: FacebookLeadgenFormType;
  intro: LeadCardIntro;
  questionsDesc?: string;
  questions: LeadCardQuestion[];
  privacy: LeadCardPrivacySettings;
  thankYouPage?: LeadCardThankYou;
  settings: {
    locale: FacebookLeadgenLocale;
    sharing: FacebookLeadgenSharingOptions;
    trackingParams?: {
      [key: string]: string;
    };
  };
}

export const exampleLeadCardCreateDTO: LeadCardCreateDTO = {
  formName: 'New Form',
  formType: 'more_volume',
  intro: {
    imageID: exampleAdImage.id,
    imageURL: exampleAdImage.url,
    greeting: {
      headline: 'Headline',
      bodyStyle: 'LIST_STYLE',
      bodyItems: ['Here is my text', 'again again'],
    },
  },
  questionsDesc: 'Please fill out the form',
  questions: [
    { type: FacebookLeadgenQuestionType.CITY },
    {
      type: FacebookLeadgenQuestionType.CUSTOM,
      format: 'multiple-choice',
      options: [
        { key: 'A', value: 'a' },
        { key: 'B', value: 'b' },
      ],
      key: 'a_or_b',
      label: 'Choose a or b',
    },
  ],
  privacy: {
    link: 'url.com',
    text: 'example.com',
    customDisclaimer: {
      title: 'please note',
      body: 'review please',
      checkboxes: [
        { isRequired: true, isCheckedByDefault: true, text: 'i agree' },
      ],
    },
  },
  thankYouPage: {
    headline: 'headline here',
    description: 'thank you so much',
    callToAction: FacebookLeadgenButtonType.VIEW_WEBSITE,
    buttonText: 'click me',
    link: 'link.com',
  },
  settings: {
    locale: FacebookLeadgenLocale.EN_US,
    sharing: 'restricted',
    trackingParams: { foo: 'bar' },
  },
};
